// extracted by mini-css-extract-plugin
export default {"footer":"datePickerExamples_footer__7sQgT"};